import { useSelector } from 'react-redux';
import { canAccess } from 'helpers/adminPermissions';

export default function useAdminPermission(menu) {
  const auth = useSelector((state) => state.auth);

  return {
    canView: canAccess(auth, menu, 'view'),
    canCreate: canAccess(auth, menu, 'create'),
    canEdit: canAccess(auth, menu, 'edit'),
    canDelete: canAccess(auth, menu, 'delete'),
  };
}
